import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogHeader, DialogTitle, DialogBody, DialogFooter } from "../../Shared/Dialog";
import Button from "../../Shared/Buttons/Button";
import { color, radius } from "../../Shared/tokens";
import { FlowBoxIllustration, FlowBoxPairingSteps } from "./FlowBoxPairingGuide";

/**
 * Explains how to put a FlowBox in connection mode, with a large animation.
 *
 * @param {boolean}  open
 * @param {function} onClose
 * @param {number}   buttonCount
 */
function FlowBoxPairingGuideDialog({ open, onClose, buttonCount = 5 }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogHeader>
        <DialogTitle>{t("flowBox.pairing.title")}</DialogTitle>
      </DialogHeader>
      <DialogBody>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "24px 16px",
            marginBottom: 16,
            borderRadius: radius.md,
            background: color.surface.subtle,
            border: `1px solid ${color.border.default}`,
          }}
        >
          <FlowBoxIllustration buttonCount={buttonCount} width={280} />
        </div>
        <FlowBoxPairingSteps />
      </DialogBody>
      <DialogFooter>
        <Button onClick={onClose}>{t("flowBox.pairing.gotIt")}</Button>
      </DialogFooter>
    </Dialog>
  );
}

export default FlowBoxPairingGuideDialog;
